import React, { useState } from 'react';
import '../styles/SearchContainer.css';
import AddReviewModal from './AddReviewModal';
import Place from '../interfaces/Place';
import SearchContainerProps from '../interfaces/SearchContainerProps';
import GeoSearch from './GeoSearch';
import { Alert } from '@mui/material';
import { Interface } from '../interfaces/Interface';

const SearchContainer: React.FC<SearchContainerProps> = ({ setMarker, isAuthenticated, setShowToast }) => {
  const [showModal, setShowModal] = useState(false);
  const [showAuthAlert, setShowAuthAlert] = useState(false);
  const [place, setPlace] = useState<Place>(Interface.emptyInterface<Place>());

  const handleAddReviewClick = () => {
    if (isAuthenticated) {
      setShowModal(true);
      setShowAuthAlert(false); // Hide the alert when the modal is shown
    } else 
      setShowAuthAlert(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleSearchClick = () => {
    setMarker(place);
  };

  return (
    <div>
      <div className="search-container">
        <div className="search-content">
          <div id="address-search">
            <GeoSearch setPlace={setPlace} />
            <button className="search-btn" type="submit" onClick={handleSearchClick}>
              <i className="search" aria-hidden="true" />
            </button>
          </div>
          <button type="submit" className="lg-btn addReview" onClick={handleAddReviewClick}>
            Agregar reseña
          </button>
        </div>
        <AddReviewModal showModal={showModal} onCloseModal={handleCloseModal} setShowToast={setShowToast} initialPlace={place} />
      </div>
      {showAuthAlert && (
        <div className="alert-container">
          <Alert severity="info" onClose={() => setShowAuthAlert(false)}>
            Autentícate para agregar una reseña
          </Alert>
        </div>
      )}
    </div>
  );
};

export default SearchContainer;
